import React, { useRef } from "react";
import { getLastSelectedHallFromStorage } from "../../../../../utils/storage/halls";
import { Slider } from "../../../../../components";
import { Swiper as SwiperType } from "swiper";
import Styles from "./../OurClub/OurClub.module.scss";

export const PhotoRenderPage: React.FC = () => {
    const lstHall = getLastSelectedHallFromStorage();
    const swiperRef = useRef<SwiperType | null>(null);

    const imagesArray = lstHall?.images || [];
    const imagesClubArray = imagesArray.map((image: any) => image.url || image).filter((url: string) => url !== "");

    const handleSmallImageClick = (index: number) => {
        if (swiperRef.current) {
            swiperRef.current.slideTo(index);
        }
    };

    const renderSmallImages = () => {
        if (imagesClubArray.length === 0) {
            return null;
        }
        return imagesClubArray.map((imageUrl: string, index: number) => {
            return (
                <img 
                    key={index} 
                    className={Styles.imgAdaptiveSub} 
                    src={imageUrl} 
                    alt={`${lstHall?.title || 'Фото'} ${index + 1}`}
                    onClick={() => handleSmallImageClick(index)}
                />
            );
        });
    };

    if (!lstHall || imagesClubArray.length === 0) {
        return (
            <div className={Styles.wrapper}>
                <div>Нет доступных фотографий</div>
            </div>
        );
    }

    return (
        <div className={Styles.wrapper}>
            <div className={Styles.slider}>
                <Slider 
                    newStyle={'slider_big_img'} 
                    images={imagesClubArray}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                />
            </div>
            {imagesClubArray.length > 0 && (
                <div className={Styles.imgContainer}>
                    {renderSmallImages()}
                </div>
            )}
        </div>
    );
};
